import TriggerBase from "./Base";
import {useTranslation} from "react-i18next";

const ManualSwitchTrigger = ({trigger, canUpdate, update}) => {
    const { t } = useTranslation();
    return (
        <>
            <TriggerBase trigger={trigger} />
            {canUpdate && (
                <tr>
                    <td>&nbsp;</td>
                    <td>
                        <button
                            className="button"
                            id="pop-up-button"
                            style={{ width: "80px" }}
                            onClick={() => update(true)}
                        >
                            {t("allgemein.an")}
                        </button>

                        <button
                            className="button"
                            id="pop-up-button"
                            style={{ width: "80px" }}
                            onClick={() => update(false)}
                        >
                            {t("allgemein.aus")}
                        </button>
                    </td>
                </tr>
            )}
        </>
    )
}

export default ManualSwitchTrigger
